import Modal from "@mui/material/Modal";
import {kModalStyles} from "../../../constants/styles";
import {kSystemIcons} from "../../../constants/icons";
import SystemScreenInfoHeader from "../../headers/SystemScreenInfoHeader";

export default function LevelAScreenInfoDialog({open, handleClose}) {
    // Used through app screen headers to handle info about current
    // screen concept

    // BUILD
    return (
        <Modal open={open}
               onClose={handleClose}>
            <div className={kModalStyles.screenInfoDialogStyle}>
                <SystemScreenInfoHeader handleClose={handleClose}
                                        icon={kSystemIcons.gear}
                                        title={"Savoir-faire"} />
                {/** CONTENT */}
                <div className={"w-full flex justify-between items-start space-x-[24px] p-[24px]"}>
                    <div className={"flex flex-col justify-start items-start space-y-[12px]"}>
                        <span className={"font-bold text-[20px] text-white -mt-[6px]"}>
                            {"En math, connaître son cours par coeur ne suffit pas\u00A0: il faut savoir s'en servir pour résoudre des exercices."}
                        </span>
                        <span className={"font-normal text-[14px] text-greyLight9"}>
                            {"Certains exercices demandent d’appliquer directement le cours, on parle alors d'un savoir-faire fondamental, quand d’autres demandent de combiner plusieurs notions pour arriver à la solution. " +
                             "Chez Ummia, on se concentre seulement sur les savoir-faire fondamentaux. Chacun d'eux repose sur une connaissance à mémoriser (définition, méthode, formule...). Il est accompagné d'un exercice type. " +
                             "Ensuite à toi de montrer que tu maîtrises définitivement le savoir-faire avec les questions flash."}
                        </span>
                    </div>
                </div>
            </div>
        </Modal>
    );
}